var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 14.375C9.91218 14.375 8.625 13.0878 8.625 11.5C8.625 9.91218 9.91218 8.625 11.5 8.625C13.0878 8.625 14.375 9.91218 14.375 11.5C14.375 13.0878 13.0878 14.375 11.5 14.375Z",
    stroke: "white",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.9165 10.6564C1.9165 9.65971 2.73109 8.83555 3.73734 8.83555C5.47192 8.83555 6.18109 7.60888 5.309 6.1043C4.81067 5.2418 5.10775 4.12055 5.97984 3.62222L7.63775 2.67347C8.39484 2.22305 9.37234 2.49138 9.82275 3.24847L9.92817 3.43055C10.7907 4.93513 12.209 4.93513 13.0811 3.43055L13.1865 3.24847C13.6369 2.49138 14.6144 2.22305 15.3715 2.67347L17.0294 3.62222C17.9015 4.12055 18.1986 5.2418 17.7003 6.1043C16.8282 7.60888 17.5373 8.83555 19.2719 8.83555C20.2686 8.83555 21.0928 9.65013 21.0928 10.6564V12.343C21.0928 13.3397 20.2782 14.1639 19.2719 14.1639C17.5373 14.1639 16.8282 15.3905 17.7003 16.8951C18.1986 17.7672 17.9015 18.8789 17.0294 19.3772L15.3715 20.326C14.6144 20.7764 13.6369 20.508 13.1865 19.751L13.0811 19.5689C12.2186 18.0643 10.8003 18.0643 9.92817 19.5689L9.82275 19.751C9.37234 20.508 8.39484 20.7764 7.63775 20.326L5.97984 19.3772C5.10775 18.8789 4.81067 17.7576 5.309 16.8951C6.18109 15.3905 5.47192 14.1639 3.73734 14.1639C2.73109 14.1639 1.9165 13.3397 1.9165 12.343V10.6564Z",
    stroke: "white",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/SETTINGS.be64252a.svg";
export { ForwardRef as ReactComponent };